<template>
  <div>
    <EditButton :disabled="!$atividades.permissoes.includes(14)" @func="modalEditarCentroCusto = true"></EditButton>
    <SideBar
      title="Editar centroCusto"
      @hide="cancelar"
      :active="modalEditarCentroCusto"
      :item="centroCusto"
      textSucces="Atualizar"
      :disabled="!$atividades.permissoes.includes(15)"
      @excluir="excluirCentroCusto"
      @status="mudarStatusCentroCusto"
      @success="submitForm()"
      size="small"
    >
      <div slot="body">
        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              class="inputx w-full"
              name="nome"
              v-validate="'required'"
              label-placeholder="Nome"
              v-model="centroCusto.nome"
            />
            <span class="text-danger text-sm" v-show="errors.has('nome')">{{
              $validators.empty
            }}</span>
          </vs-col>
        </vs-row>
      </div>
    </SideBar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";

export default {
  name: "modalEditarCentroCusto",
  props: { centroCusto: Object },
  data() {
    return {
      modalEditarCentroCusto: false,
      error: false,
      originalData: {}
    };
  },
  mounted() {
    this._beforeEditingCache = Object.assign({}, this.centroCusto);
    this.originalData = this.centroCusto;
  },
  methods: {
    async submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.editarCentroCusto();
        } else {
          this.error = true;
          this.$vs.notify(this.$notify.Empty);
        }
      });
    },
    async editarCentroCusto() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          this.$vs.loading();
          try {
            const res = await this.$http.put(
              `centro_custo/${this.centroCusto.id}`,
              this.centroCusto
            );
            let logData = {
              id_colaborador: localStorage.getItem("id"),
              funcao: 'atualizar',
              setor: 'financeiro',
              ip: window.localStorage.getItem("ip"),
              texto: 'Edição do centro de custos N°' + res.id}
            await this.$logger(logData)

            this.modalEditarCentroCusto = false;
          } catch (err) {
            const error = this.$httpErrors(err);
            this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
          } finally {
            this.$vs.loading.close();
          }
        }
      });
    },
    async excluirCentroCusto() {
      this.$vs.loading();
      try {
        await this.$http.delete(`centro_custo/${this.centroCusto.id}`);
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: 'excluir',
          setor: 'financeiro',
          ip: window.localStorage.getItem("ip"),
          texto: 'Exclusão do centro de custos N°' + this.centroCusto.id}
        await this.$logger(logData)

        this.$vs.notify(this.$notify.Success);
        this.modalEditarCentroCusto = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
    async mudarStatusCentroCusto() {
      this.$vs.loading();
      try {
        const res = await this.$http.put(`centro_custo/${this.centroCusto.id}`, {
          lixeira: !this.centroCusto.lixeira
        });
        let logData = {
            id_colaborador: localStorage.getItem("id"),
            funcao: 'atualizar',
            setor: 'comercial',
            ip: window.localStorage.getItem("ip"),
            texto: 'Mudar status do centro de custos N°' + res.id}
          await this.$logger(logData)
        this.$vs.notify(this.$notify.Success);
        this.modalEditarCentroCusto = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
    cancelar() {
      Object.assign(this.centroCusto, this._beforeEditingCache);
      this.originalData = this._beforeEditingCache = null;
      this.modalEditarCentroCusto = false;
    }
  },
  components: components
};
</script>

<style></style>
